import { render, staticRenderFns } from "./EditMaterialAdmin.vue?vue&type=template&id=6a064764&scoped=true"
import script from "./EditMaterialAdmin.vue?vue&type=script&lang=js"
export * from "./EditMaterialAdmin.vue?vue&type=script&lang=js"
import style0 from "./EditMaterialAdmin.vue?vue&type=style&index=0&id=6a064764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a064764",
  null
  
)

export default component.exports